<template>
  <div id="file">
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("file.title") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("file.titlein") }}</em></small
        >
      </div>
      <div class="space"></div>
      <a-skeleton active :loading="cardLodaing">
        <div class="card">
          <div class="card-head" style="margin-bottom: 20px">
            <a-select
              v-model:value="selectDevice"
              style="width: 200px"
              show-search
              :options="options"
              :filter-option="filterOption"
              @change="handleChange"
            ></a-select>
            <a-input-search
              v-model:value="searchValue"
              :placeholder="$t('file.search')"
              enter-button
              style="width: 400px"
              @search="searchTableByName()"
            />
            <a-button @click="openForm()">
              <upload-outlined></upload-outlined>
              {{ $t("file.upload") }}
            </a-button>
          </div>

          <a-table
            :dataSource="tableData"
            :columns="columns"
            :loading="tableLoading"
            :row-key="(record) => record.Id"
          >
            <template #operator class="table-operator"> </template>
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'action'">
                <a @click="camReport(record)">{{ $t("file.camReport") }}</a>
                <a-divider type="vertical" />
                <a @click="workReport(record)">{{ $t("file.workReport") }}</a>
                <a-divider type="vertical" />
                <a @click="downloadReport(record)">{{ $t("file.downloadReport") }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('file.deletein')" @confirm="removeOrg(record)">
                  <a-button type="link" danger size="small">{{
                    $t("file.delete")
                  }}</a-button>
                </a-popconfirm>
              </template>
            </template>
          </a-table>
        </div>
      </a-skeleton>
    </div>
  </div>

  <a-drawer
    :title="$t('file.drawerTitle1')"
    :open="formOpen"
    :width="720"
    @close="onClose"
  >
    <a-form :modle="form" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('file.orderNumber')" name="orderNumber">
            <a-select
              v-model:value="form.orderNumber"
              style="width: 200px"
              show-search
              :options="options"
              :filter-option="filterOption"
            ></a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('file.uFile')" name="Upload">
            <a-upload-dragger
              :file-list="fileList"
              @remove="handleRemove"
              :multiple="true"
              :before-upload="beforeUpload"
            >
              <p class="ant-upload-drag-icon">
                <inbox-outlined></inbox-outlined>
              </p>
              <p class="ant-upload-text">{{ $t("file.uploadBox") }}</p>
            </a-upload-dragger>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template #extra>
      <a-space>
        <a-button @click="onClose">{{ $t("file.close") }}</a-button>
        <a-button
          type="primary"
          :disabled="fileList.length === 0"
          :loading="uploading"
          @click="handleUpload"
          >{{ uploading ? "Uploading" : $t("file.submit") }}</a-button
        >
      </a-space>
    </template>
  </a-drawer>

  <a-drawer
    :title="$t('file.workReport')"
    :open="workReportOpen"
    :width="1000"
    @close="onworkReportClose"
  >
    <a-skeleton active :loading="workReportLoad">
      <a-empty v-if="workReportEmpty" :image="simpleImage" />
      <a-descriptions
        bordered
        :column="3"
        v-if="workReportDataTube.length > 0"
        v-for="data in workReportDataTube"
        style="margin-bottom: 30px"
      >
        <a-descriptions-item :label="$t('file.orderNumber')">{{
          data.OrderNumber
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.processType')">
          <a-tag v-if="data.ProcessType == 1" color="blue">
            {{ $t("file.process") }}
          </a-tag>
          <a-tag v-if="data.ProcessType == 0" color="orange">
            {{ $t("file.emptyOperation") }}
          </a-tag></a-descriptions-item
        >
        <a-descriptions-item :label="$t('file.thickness')">{{
          data.Thickness
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.partCount')">{{
          data.PartCount
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.pierceCount')">{{
          data.PierceCount
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.pierceDuration')">{{
          data.PierceDuration
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.idleLength')">{{
          data.IdleLength
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.slicingLength')">{{
          data.SlicingLength
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.slicingDuration')">{{
          data.SlicingDuration
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.totalDuration')">{{
          data.TotalDuration
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.startTime')">{{
          data.StartTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.endTime')">{{
          data.EndTime
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.useTubeCount')">{{
          data.UseTubeCount
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.isComplete')">
          <a-tag v-if="data.IsComplete == 0" color="orange">
            {{ $t("file.notCompleted") }}
          </a-tag>
          <a-tag v-if="data.IsComplete == 1" color="blue">
            {{ $t("file.completed") }}
          </a-tag></a-descriptions-item
        >
        <a-descriptions-item :label="$t('file.fileName')" :column="3">{{
          data.FileUrl
        }}</a-descriptions-item>
      </a-descriptions>

      <a-descriptions
        bordered
        :column="3"
        v-if="workReportDataSheet.length > 0"
        v-for="data in workReportDataSheet"
        style="margin-bottom: 30px"
      >
        <a-descriptions-item :label="$t('file.orderNumber')">{{
          data.OrderNumber
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.machineName')">
          {{ data.MachineName }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('file.pierceCount')">{{
          data.PunchingNum
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.idleLength')">{{
          data.EmptyLength
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.slicingLength')">{{
          data.CuttingLength
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.processingTime')">{{
          data.ProcessingTime
        }}</a-descriptions-item>

        <a-descriptions-item :label="$t('file.startTime')">{{
          data.StartTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.endTime')">{{
          data.EndTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.createTime')">{{
          data.CreateTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('file.fileName')" :column="3">{{
          data.FileUrl
        }}</a-descriptions-item>
      </a-descriptions>
    </a-skeleton>
  </a-drawer>

  <a-drawer
    :title="$t('file.camReport')"
    :open="camReportOpen"
    :width="1000"
    @close="oncamReportClose"
  >
    <a-skeleton active :loading="camReportLoad">
      <a-empty v-if="camReportEmpty" :image="simpleImage" />

      <div v-if="camReportDataTube1.length > 0">
        <a-descriptions
          :title="$t('file.camReportTube1')"
          bordered
          :column="3"
          v-for="data in camReportDataTube1"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.ProjectName')">{{
            data.ProjectName
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.CreateTime')">
            {{ data.CreateTime }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('file.Gap')">{{
            data.Gap
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.CutLength')">{{
            data.CutLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Material2')">{{
            data.Material
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.TubeInfo')">{{
            data.TubeInfo
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.TubeThickness')">{{
            data.TubeThickness
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.SectionInfo')">{{
            data.SectionInfo
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.SectionType')">{{
            data.SectionType
          }}</a-descriptions-item>
        </a-descriptions>

        <a-typography-title
          :level="5"
          v-if="camReportDataTube2.length > 0"
          style="margin-bottom: 20px"
          >{{ $t("file.camReportTube2") }}</a-typography-title
        >
        <a-descriptions
          bordered
          :column="3"
          v-for="data in camReportDataTube2"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.ID')">{{ data.ID }}</a-descriptions-item>
          <a-descriptions-item :span="2" :label="$t('file.Sort')">
            {{ data.Sort }}
          </a-descriptions-item>

          <a-descriptions-item :label="$t('file.NestTubeID')">{{
            data.NestTubeID
          }}</a-descriptions-item>
          <a-descriptions-item :span="2" :label="$t('file.SortName')">{{
            data.Name
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Length')">{{
            data.Length
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.SurplusLength')">{{
            data.SurplusLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.partCount')">{{
            data.PartsCount
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.UsedTubeCount')">{{
            data.UsedTubeCount
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.UtilizationRate')">{{
            data.Utilization
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Count2')">{{
            data.Count
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.CutLength')">{{
            data.CutLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.AirLength')">{{
            data.AirLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.PerforationCount')">{{
            data.PerforationCount
          }}</a-descriptions-item>
        </a-descriptions>

        <a-typography-title
          :level="5"
          v-if="camReportDataTube3.length > 0"
          style="margin-bottom: 20px"
          >{{ $t("file.camReportTube3") }}</a-typography-title
        >
        <a-descriptions
          bordered
          :column="3"
          v-for="data in camReportDataTube3"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.ID')">{{ data.ID }}</a-descriptions-item>
          <a-descriptions-item :span="2" :label="$t('file.Name2')">{{
            data.Name
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Sort2')">
            {{ data.Sort }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('file.Size2')">{{
            data.Size
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Weight2')">{{
            data.Weight
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Count3')">{{
            data.Count
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.UsedCount')">{{
            data.UsedCount
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.SurplusCount')">{{
            data.SurplusCount
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.img')" :span="3">
            <img
              :src="`https://apicloud.bodor.com${data.ImageFile}`"
              alt=""
              width="100px"
              height="100px"
            />
          </a-descriptions-item>
        </a-descriptions>

        <a-typography-title
          :level="5"
          v-if="camReportDataTube4.length > 0"
          style="margin-bottom: 20px"
          >{{ $t("file.camReportTube4") }}</a-typography-title
        >
        <a-descriptions
          bordered
          :column="3"
          v-for="data in camReportDataTube4"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.ID')">{{ data.ID }}</a-descriptions-item>
          <a-descriptions-item :span="2" :label="$t('file.Name3')">{{
            data.Name
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Sort3')">
            {{ data.Sort }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('file.Section')">{{
            data.Section
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Length2')">{{
            data.Length
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Count4')">{{
            data.Count
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.UsedCount2')">{{
            data.UsedCount
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.SurplusCount2')">{{
            data.SurplusCount
          }}</a-descriptions-item>
        </a-descriptions>
      </div>

      <div v-if="camReportDataSheet1.length > 0">
        <a-descriptions
          :title="$t('file.camReportSheet1')"
          bordered
          :column="3"
          v-for="data in camReportDataSheet1"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.Material')">{{
            data.Material
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.TaskName')">
            {{ data.TaskName }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('file.PlateSize')">{{
            data.PlateSize
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Thickness')">{{
            data.Thickness
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Density')">{{
            data.Density
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.PlateCount')">{{
            data.PlateCount
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.PlateWeight')">{{
            data.PlateWeight
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.PlateName')">{{
            data.PlateName
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.UtilizationRate')">{{
            data.UtilizationRate
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.partCount')">{{
            data.PartsCount
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.pierceCount')">{{
            data.PerforationCount
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.PerforationTime')">{{
            data.PerforationTime
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.idleLength')">{{
            data.AirLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.idleTime')">{{
            data.AirTime
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.slicingLength')">{{
            data.CutLength
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.cutTime')">{{
            data.CutTime
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.processingTime')">{{
            data.ProcessingTime
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.NestName')">{{
            data.NestName
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.sheetImg')" :span="3">
            <img
              :src="`https://apicloud.bodor.com${data.ImageFile}`"
              alt=""
              width="100px"
              height="100px"
            />
          </a-descriptions-item>
        </a-descriptions>
        <a-typography-title
          :level="5"
          v-if="camReportDataSheet2.length > 0"
          style="margin-bottom: 20px"
          >{{ $t("file.camReportSheet2") }}</a-typography-title
        >
        <a-descriptions
          bordered
          :column="3"
          v-for="data in camReportDataSheet2"
          style="margin-bottom: 30px"
        >
          <a-descriptions-item :label="$t('file.Code')">{{
            data.Code
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Name')">
            {{ data.Name }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('file.Size')">{{
            data.Size
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.Count')">{{
            data.Count
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.Weight')">{{
            data.Weight
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.LayoutQuantity')">{{
            data.LayoutQuantity
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.SurPlusQuantity')">{{
            data.SurplusQuantity
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.PartCutLength')">{{
            data.PartCutLength
          }}</a-descriptions-item>
          <a-descriptions-item :label="$t('file.CreateTime')">{{
            data.CreateTime
          }}</a-descriptions-item>

          <a-descriptions-item :label="$t('file.img')" :span="3">
            <img
              :src="`https://apicloud.bodor.com${data.PartImageFile}`"
              alt=""
              width="100px"
              height="100px"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-skeleton>
  </a-drawer>
</template>
<script setup>
/**
 * CreationTime: 2024.09.05 Thr
 * LastEditTime: 2024.09.11 Wen
 * Written by Shi-Ye-Chen
 */
import { ref, reactive } from "vue";
import { onMounted, onUnmounted } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
import { message, drawer } from "ant-design-vue";
import { UploadOutlined, InboxOutlined } from "@ant-design/icons-vue";
import { Empty } from "ant-design-vue";

const { t } = useI18n();

localStorage.setItem("router", "file");

/**用户信息 */
const user = ref();
user.value = JSON.parse(localStorage.getItem("user"));
/**表格相关内容 */
const tableData = ref([]);
const columns = ref([
  {
    title: t("file.fileName"),
    dataIndex: "FileName",
  },
  {
    title: t("file.createTime"),
    dataIndex: "CreateTime",
  },
  {
    title: t("file.orderNumber"),
    dataIndex: "OrderNumber",
  },
  {
    title: "操作",
    dataIndex: "action",
    align: "center",
    width: "300px",
  },
]);
const tableLoading = ref(false);
/**下拉菜单相关内容 */
const options = ref([]);
const selectDevice = ref(undefined);
/**搜索框相关内容 */
const searchValue = ref();
/**文件上传抽屉相关内容 */
const formOpen = ref(false);
const form = ref({
  orderNumber: undefined,
});
const rules = {};
const uploadedList = ref([]);
const fileList = ref([]);
const uploading = ref(false);
const cardLodaing = ref(false);
/**加工报告抽屉相关内容*/
const workReportOpen = ref(false);
const workReportEmpty = ref(true);
const workReportLoad = ref(false);
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
/**管机加工报告 */
const workReportDataTube = ref([]);
/**板机加工报告 */
const workReportDataSheet = ref([]);
/**cam报告抽屉相关内容 */
const camReportOpen = ref(false);
const camReportEmpty = ref(true);
const camReportLoad = ref(false);
/**管机cam加工报告 */
const camReportDataTube1 = ref([]);
const camReportDataTube2 = ref([]);
const camReportDataTube3 = ref([]);
const camReportDataTube4 = ref([]);
/**板机cam加工报告 */
const camReportDataSheet1 = ref([]);
const camReportDataSheet2 = ref([]);

/**
 * 入口函数,程序首先会执行的函数
 */
async function init() {
  getMyDevice();
}

init();

async function getTableData() {
  try {
    tableLoading.value = true;
    const response = await axios.post("api/IndustrialDocument/WebGetList", {
      OrderNumber: selectDevice.value,
    });
    tableLoading.value = false;
    if (!response.data.code == 200) throw new Error(response.info);
    let returnData = response.data.ReturnData;
    if (Array.isArray(returnData)) {
      tableData.value = returnData;
    }
  } catch (err) {
    message.error(t("file.fail1") + err.toString());
  }
}

async function searchTableByName() {
  if (searchValue.value) {
    try {
      tableLoading.value = true;
      const response = await axios.post("api/IndustrialDocument/WebGetList", {
        FileName: searchValue.value,
      });
      tableLoading.value = false;
      if (!response.data.code == 200) throw new Error(response.info);
      let returnData = response.data.ReturnData;
      if (Array.isArray(returnData)) {
        tableData.value = returnData;
      }
    } catch (err) {
      message.error(t("file.fail1") + err.toString());
    }
  } else {
    message.warn(t("file.searchErr"));
  }
}

async function getMyDevice() {
  try {
    cardLodaing.value = true;
    const response = await axios.post("api/Machine/GetMyMachine", {
      UserId: user.value.UserId,
    });

    if (!response.data.code == 200) throw new Error(response.info);
    let returnData = response.data.ReturnData;
    if (Array.isArray(returnData)) {
      returnData.forEach((data) => {
        options.value.push({
          value: data.ordernumber,
          label: data.ordernumber,
        });
      });

      selectDevice.value = options.value[0].value;
      getTableData();
      cardLodaing.value = false;
    }
  } catch (err) {
    message.error(t("file.fail2") + err.toString());
  }
}

async function removeOrg(record) {
  try {
    const response = await axios.post("api/IndustrialDocument/Delete", {
      Id: record.Id,
    });

    if (!response.data.code == 200) {
      throw new Error(response.info);
    } else {
      message.success("删除成功!");
      getTableData();
    }
  } catch (err) {
    message.error(t("file.fail3") + err.toString());
  }
}

function openForm() {
  form.value.orderNumber = selectDevice.value;
  formOpen.value = true;
}

const handleRemove = (file) => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();
  newFileList.splice(index, 1);
  fileList.value = newFileList;
};
const beforeUpload = (file) => {
  fileList.value = [...fileList.value, file];
  return false;
};
function containsPlusSymbol(arr) {
  // 使用 some() 方法检查数组中是否有元素包含 "+"
  return arr.some((element) => element.includes("+"));
}
const handleUpload = () => {
  const fileUnAccept = [];
  fileList.value.map((file) => {
    fileUnAccept.push(file.name);
  });
  if (containsPlusSymbol(fileUnAccept)) {
    message.error(t("file.submitError"));
    setTimeout(function () {
      fileList.value = [];
    }, 0);

    return;
  } else {
    let fileData = new FormData();

    if (fileList.value.length > 0) {
      fileList.value.map((file) => {
        fileData.append("files", file);
      });
    }
    fileData.append("orderNumber", form.value.orderNumber);
    uploading.value = true;
    axios
      .post("/api/IndustrialDocument/UploadListDocument", fileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        uploading.value = false;
        if (response.data.code != 200) {
          message.error(response.data.info);
        } else {
          message.success(t("file.success"));
          form.value = {
            orderNumber: undefined,
          };
          formOpen.value = false;
          getTableData();
        }
      })
      .catch(() => {
        uploading.value = false;
        message.error(t("file.fail"));
      })
      .finally(() => {
        fileList.value = [];
      });
  }
};

const onClose = () => {
  fileList.value = [];
  formOpen.value = false;
};

const handleChange = (value) => {
  getTableData();
};

const filterOption = (input, option) => {
  return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

function workReport(record) {
  workReportOpen.value = true;
  if (record.Id) {
    getWorkReport(record.Id);
  }
}

function downloadReport(record) {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = "https://apicloud.bodor.com" + record.FilePath;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", record.OrderNumber);
  link.setAttribute("target", "_blank");
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
}

async function getWorkReport(id) {
  try {
    workReportLoad.value = true;
    let response = await axios.post("api/IndustrialDocument/GetTubeMachineReport", {
      Id: id,
    });

    if (!response.data.code == 200) {
      throw new Error(response.info);
    } else {
      let returnData = response.data.ReturnData;
      if (Array.isArray(returnData) && returnData.length > 0) {
        workReportEmpty.value = false;
        workReportDataTube.value = returnData;
      } else {
        response = await axios.post("api/IndustrialDocument/GetPlateMachineReport", {
          Id: id,
        });

        if (!response.data.code == 200) {
          throw new Error(response.info);
        } else {
          returnData = response.data.ReturnData;
          if (Array.isArray(returnData) && returnData.length > 0) {
            workReportEmpty.value = false;
            workReportDataSheet.value = returnData;
          } else {
            workReportEmpty.value = true;
          }
        }
      }
    }
    workReportLoad.value = false;
  } catch (err) {
    message.error(t("file.fail4") + err.toString());
  }
}

const onworkReportClose = () => {
  workReportOpen.value = false;
  workReportEmpty.value = true;
  workReportDataTube.value = [];
  workReportDataSheet.value = [];
};

function camReport(record) {
  camReportOpen.value = true;
  if (record.ProjectId) {
    getCamReport(record.ProjectId);
  }
}

async function fetchCamData(url, projectId) {
  try {
    const response = await axios.post(url, { ProjectId: projectId });
    if (response.data.code !== 200) {
      throw new Error(response.info);
    }
    return response.data.ReturnData;
  } catch (error) {
    throw error; // 重新抛出错误，以便在上层调用中处理
  }
}

async function getCamReport(id) {
  try {
    camReportLoad.value = true;
    let returnData = await fetchCamData("api/IndustrialDocument/GetReportTube", id);
    if (returnData) {
      camReportDataTube1.value = [returnData];
      camReportEmpty.value = false;

      camReportDataTube2.value = await fetchCamData(
        "api/IndustrialDocument/GetCamNests",
        id
      );
      camReportDataTube3.value = await fetchCamData(
        "api/IndustrialDocument/GetCamParts",
        id
      );
      camReportDataTube4.value = await fetchCamData(
        "api/IndustrialDocument/GetCamTubes",
        id
      );
    } else {
      returnData = await fetchCamData("api/IndustrialDocument/GetPlateReports", id);
      if (Array.isArray(returnData) && returnData.length > 0) {
        camReportDataSheet1.value = returnData;
        camReportEmpty.value = false;

        camReportDataSheet2.value = await fetchCamData(
          "api/IndustrialDocument/GetPlateParts",
          id
        );
      } else {
        camReportEmpty.value = true;
      }
    }
    camReportLoad.value = false;
  } catch (err) {
    message.error(t("file.fail5") + err.toString());
  }
}

const oncamReportClose = () => {
  camReportOpen.value = false;
  const propertiesToReset = [
    camReportDataTube1,
    camReportDataTube2,
    camReportDataTube3,
    camReportDataTube4,
    camReportDataSheet1,
    camReportDataSheet2,
  ];
  camReportEmpty.value = true;

  // 遍历数组，将每个属性的value设置为空数组
  propertiesToReset.forEach((property) => {
    if (property && property.value) {
      property.value = [];
    }
  });
};
</script>

<style scoped>
#file {
  padding: 100px 0px;
  background-color: #f7f9fa;
}

.zeropadding {
  padding: 0px;
}

.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  padding: 30px;
  background-color: white;
}

.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 0px;
}

table {
  width: 100%;
}

.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}

a {
  cursor: pointer;
  color: #1890ff;
}
</style>
